var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "notice-wrapper", class: _vm.type }, [
    _c("img", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShowClose,
          expression: "isShowClose"
        }
      ],
      staticClass: "close __pointer",
      attrs: { src: require("assets/imgs/close.svg") },
      on: {
        click: function($event) {
          return _vm.close(_vm.rawData)
        }
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("div", { staticClass: "describe" }, [_vm._v(_vm._s(_vm.describe))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }